"use strict";

var _regeneratorRuntime = require("/Users/arjunjain/Borderless/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Users/arjunjain/Borderless/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/Users/arjunjain/Borderless/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/arjunjain/Borderless/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/Users/arjunjain/Borderless/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/arjunjain/Borderless/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/Users/arjunjain/Borderless/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var lisk_cryptography_1 = require("@liskhq/lisk-cryptography");

var base_transaction_1 = require("./base_transaction");

var constants_1 = require("./constants");

var errors_1 = require("./errors");

var utils_1 = require("./utils");

exports.secondSignatureAssetFormatSchema = {
  type: 'object',
  required: ['signature'],
  properties: {
    signature: {
      type: 'object',
      required: ['publicKey'],
      properties: {
        publicKey: {
          type: 'string',
          format: 'publicKey'
        }
      }
    }
  }
};

var SecondSignatureTransaction =
/*#__PURE__*/
function (_base_transaction_1$B) {
  _inherits(SecondSignatureTransaction, _base_transaction_1$B);

  function SecondSignatureTransaction(rawTransaction) {
    var _this;

    _classCallCheck(this, SecondSignatureTransaction);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SecondSignatureTransaction).call(this, rawTransaction));
    var tx = typeof rawTransaction === 'object' && rawTransaction !== null ? rawTransaction : {};
    _this.asset = tx.asset || {
      signature: {}
    };
    return _this;
  }

  _createClass(SecondSignatureTransaction, [{
    key: "assetToBytes",
    value: function assetToBytes() {
      var publicKey = this.asset.signature.publicKey;
      return lisk_cryptography_1.hexToBuffer(publicKey);
    }
  }, {
    key: "prepare",
    value: function () {
      var _prepare = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(store) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return store.account.cache([{
                  address: this.senderId
                }]);

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function prepare(_x) {
        return _prepare.apply(this, arguments);
      }

      return prepare;
    }()
  }, {
    key: "verifyAgainstTransactions",
    value: function verifyAgainstTransactions(transactions) {
      var _this2 = this;

      return transactions.filter(function (tx) {
        return tx.type === _this2.type && tx.senderPublicKey === _this2.senderPublicKey;
      }).map(function (tx) {
        return new errors_1.TransactionError('Register second signature only allowed once per account.', tx.id, '.asset.signature');
      });
    }
  }, {
    key: "validateAsset",
    value: function validateAsset() {
      utils_1.validator.validate(exports.secondSignatureAssetFormatSchema, this.asset);
      var errors = errors_1.convertToAssetError(this.id, utils_1.validator.errors);

      if (!this.amount.eq(0)) {
        errors.push(new errors_1.TransactionError('Amount must be zero for second signature registration transaction', this.id, '.amount', this.amount.toString(), '0'));
      }

      if (this.recipientId) {
        errors.push(new errors_1.TransactionError('RecipientId is expected to be undefined.', this.id, '.recipientId', this.recipientId, ''));
      }

      if (this.recipientPublicKey) {
        errors.push(new errors_1.TransactionError('RecipientPublicKey is expected to be undefined.', this.id, '.recipientPublicKey', this.recipientPublicKey, ''));
      }

      return errors;
    }
  }, {
    key: "applyAsset",
    value: function applyAsset(store) {
      var errors = [];
      var sender = store.account.get(this.senderId);

      if (sender.secondPublicKey) {
        errors.push(new errors_1.TransactionError('Register second signature only allowed once per account.', this.id, '.secondPublicKey'));
      }

      var updatedSender = Object.assign({}, sender, {
        secondPublicKey: this.asset.signature.publicKey,
        secondSignature: 1
      });
      store.account.set(updatedSender.address, updatedSender);
      return errors;
    }
  }, {
    key: "undoAsset",
    value: function undoAsset(store) {
      var sender = store.account.get(this.senderId);
      var resetSender = Object.assign({}, sender, {
        secondPublicKey: null,
        secondSignature: 0
      });
      store.account.set(resetSender.address, resetSender);
      return [];
    }
  }, {
    key: "sign",
    value: function sign(passphrase) {
      this._signature = undefined;
      this._signSignature = undefined;
      this._signature = lisk_cryptography_1.signData(lisk_cryptography_1.hash(this.getBytes()), passphrase);
      this._id = utils_1.getId(this.getBytes());
    }
  }, {
    key: "assetFromSync",
    value: function assetFromSync(raw) {
      if (!raw.s_publicKey) {
        return undefined;
      }

      var signature = {
        transactionId: raw.t_id,
        publicKey: raw.s_publicKey
      };
      return {
        signature: signature
      };
    }
  }]);

  return SecondSignatureTransaction;
}(base_transaction_1.BaseTransaction);

SecondSignatureTransaction.TYPE = 1;
SecondSignatureTransaction.FEE = constants_1.SIGNATURE_FEE.toString();
exports.SecondSignatureTransaction = SecondSignatureTransaction;